// extracted by mini-css-extract-plugin
export default {"container":"instruction_container__LYgvc","centerContent":"instruction_centerContent__lkZ0L","text":"instruction_text__8by8N","buttonNext":"instruction_buttonNext__G78DO"};